module.exports = __webpack_public_path__ + "img/3-3-2-3.d98d6b0f.png";